<div class="btn-group" role="group">
  <ng-container *ngFor="let filter of filtersDefs">
    <input
      type="checkbox"
      class="btn-check"
      [id]="'check-filter-'+filter.name"
      autocomplete="off"
      [checked]="filterIncludes(filter.name)"
      (change)="updateFilter(filter.name)"
    />
    <label class="btn btn-outline-primary" [for]="'check-filter-'+filter.name">
      <fa-icon [icon]="filter.icon" [fixedWidth]="true" size="lg"></fa-icon> {{filter.title}}
    </label>
  </ng-container>
</div>
